/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

/**
 * Scripts to communicate with qr authenticator
 */
import io from 'socket.io-client';
class QRAuthenticator {
  constructor (socketurl, path) {
    var self = this;
    self.socket = null;
    self.events = {};
    self.socketurl = socketurl;
    self.path = path;

    self.connect = function () {
      if (self.socket == null) {
        self.socket = io.connect(
          self.socketurl,
          {
            path: self.path,
            reconnection: true,
            protocol: ['websocket']
          }
        );

        self.socket.on('code', function (data) {
          if (self.events.code) {
            self.events.code(data);
          }
        });

        self.socket.on('token', function (data) {
          if (self.events.token) {
            self.events.token(data);
          }
        });

        self.socket.on('disconnect', function () {
          if (self.events.disconnect) {
            self.events.disconnect();
          }
        });

        self.socket.on('error', function (error) {
          if (self.events.error) {
            self.events.error(error);
          }
        });
      }
    };

    self.attachEvent = function (type, callback) {
      self.events[type] = callback;
    };

    self.emit = function (event, data) {
      if (self.socket !== null) {
        if (data) {
          self.socket.emit(event, data);
        } else {
          self.socket.emit(event);
        }
      }
    };

    self.close = function () {
      if (self.socket !== null) {
        self.socket.close();
      }
    };

    self.reconnect = function () {
      if (self.socket !== null) {
        self.socket.open();
      }
    };
  }
}

export default QRAuthenticator;
